import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { toDiacriticPinyin } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { WordDrillContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";
import { View } from "@-/com.npmjs.react-native";
import type { DrillPageHeaderTextsVariant } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.header-texts";

/**
 * The front of a word card: the sentence's ENGLISH translation plus the target word's pinyin.
 *
 * The Chinese sentence is deliberately absent — it contains the answer. The user recalls which
 * characters spell the pinyin, using the translation for context, and only sees the sentence
 * itself once revealed.
 */
export function DrillPageWordSentencePrompt({ variant }: { variant: DrillPageHeaderTextsVariant }) {
  const [pinyin, translation] = useContextSelectors(
    WordDrillContext,
    (c) => c.drillType.pinyin,
    (c) => c.sentence.translation,
  );

  const translationClassName =
    variant === "landscape-compact"
      ? "text-center font-sans text-[16px] leading-tight"
      : "text-center font-sans text-[20px]";
  const pinyinClassName =
    variant === "landscape-compact"
      ? "text-center font-sans text-[28px] text-foreground"
      : "text-center font-sans text-[40px] text-foreground";

  return (
    <View className="w-full items-center gap-4 px-2">
      <Text className={translationClassName} colorVariant="muted">
        {`“${translation}”`}
      </Text>
      <Text className={pinyinClassName} colorVariant="default">
        {toDiacriticPinyin(pinyin)}
      </Text>
    </View>
  );
}
